<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <v-autocomplete
          ref="controlFocoSelectProveedor"
          label="Proveedor*"
          v-model="itemActivo.Id_Proveedor"
          :items="items"
          item-value="Id_Proveedor"
          item-text="NombreRazonSocialCuit"
          :search-input.sync="palabraBuscada"
          :rules="rules"
          :readonly="readonly"
          :loading="loading"
          outlined
          hide-details
          clearable
          auto-select-first
          @change="buscar"
          @keyup.enter="listar"
          @click:clear="inicializar"
          @click:append="listar"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title
                v-text="item.NombreRazonSocialCuit"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-icon small>info</v-icon>
            <small>
              Ingrese el texto a buscar y presione
              <strong>ENTER</strong>
            </small>
          </template>
          <template v-slot:progress>
            <v-progress-circular
              color="blue"
              indeterminate
            ></v-progress-circular>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-text>
            <small v-if="itemActivo.Id_Proveedor != 0">
              {{ itemActivo.NombreTipoIva }}
              {{ this.itemActivo.Direccion }} / Tel.
              {{ this.itemActivo.Telefono }} / E-mail
              {{ this.itemActivo.Email }}
            </small>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectProveedor",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      itemVacio: {
        Id_Proveedor: null,
        RazonSocial: null,
        Direccion: null,
        Telefono: null,
        Email: null,
        Id_TipoIva: "I",
        NombreTipoIva: null
      },
      itemActivo: {},
      items: [],
      palabraBuscada: null,
      loading: false
    };
  },
  watch: {
    model(valor) {
      if (valor && valor != this.itemActivo.Id_Proveedor) this.cargar(valor);
    }
  },
  created() {
    eventBus.$on("inicializarSelectProveedor", this.inicializar);
    eventBus.$on("setearFocoSelectProveedor", this.setearFoco);
  },
  beforeDestroy() {
    eventBus.$off("inicializarSelectProveedor", this.inicializar);
    eventBus.$off("setearFocoSelectProveedor", this.setearFoco);
  },
  methods: {
    inicializar() {
      this.loading = true;
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.items = [];
      this.palabraBuscada = "";
      HttpHelper.get("TipoIva/Buscar", {
        id: this.itemActivo.Id_TipoIva
      })
        .then(response => {
          this.itemActivo.NombreTipoIva = response.data.Nombre;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    cargar(valor) {
      if (valor) {
        this.loading = true;
        HttpHelper.get("Proveedor/", {
          id: valor
        })
          .then(response => {
            this.items.push(response.data);
            this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    listar() {
      if (this.palabraBuscada && this.palabraBuscada.length > 0) {
        this.loading = true;
        HttpHelper.get("Proveedor/ListarSelect/", {
          palabra: this.palabraBuscada
        })
          .then(response => {
            this.items = response.data;
            if (this.items.length == 1) this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    buscar(id) {
      if (id) {
        let ind = this.items.findIndex(x => x.Id_Proveedor == id);
        this.seleccionarItem(this.items[ind]);
      } else this.$emit("seleccionarItem", this.itemVacio);
    },
    seleccionarItem(item) {
      this.itemActivo = item;
      this.$emit("seleccionarItem", this.itemActivo);
    },
    setearFoco() {
      this.$refs.controlFocoSelectProveedor.focus();
    }
  }
};
</script>
